module.exports = __webpack_public_path__ + "static/img/4.b91759d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/1/zh/4.png
// module id = CdTI
// module chunks = 0